import { getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackEvent } from '../../../client/analytics';

import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

const EVENT_IDS = {
  START_DEACTIVATION: '3415',
  PRINT_PROPERTY_SHEET: '3684',
} as const;

// https://dataportal.zillowgroup.net/event-registry/3415
const StartDeactivation = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.START_DEACTIVATION,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'sense_of_home|find_tenants',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'deactivate_listing',
    },
    semantic: {
      semantic_event_nm: 'start_deactivation',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3684
const PrintPropertySheet = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.PRINT_PROPERTY_SHEET,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'sense_of_home|find_tenants',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'property_summary_sheet',
      trigger_source_nm: 'print_property_sheet',
    },
    semantic: {
      semantic_event_nm: 'print_property_summary_sheet',
      topic_tag_txt: ['rental_application'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

const FindTenantsPageCSEvents = {
  StartDeactivation,
  PrintPropertySheet,
};

// Clickstream visualizer data-eventid attributes
StartDeactivation.data_event_id = EVENT_IDS.START_DEACTIVATION;
PrintPropertySheet.data_event_id = EVENT_IDS.PRINT_PROPERTY_SHEET;

export default FindTenantsPageCSEvents;
